import comp from "./CareersCRUD";
export default comp;
